// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "network.gridlock",
    name: "Gridlock Wallet",
    homepage: "https://gridlock.network/",
    image_id: "471e6f61-b95a-453c-670c-029ef3b2bd00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/app/gridlock-secure-crypto-wallet/id1567057330",
        android: "https://play.google.com/store/apps/details?id=network.gridlock.AppGridlock",
        mac: "",
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "network.gridlock.AppGridlock://",
        universal: "https://gridlock.page.link/Fihx",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map